import { useEffect } from "react";

const SITE_ORIGIN = "https://ambassadors.noobsync.com";

function upsertMeta(selector, attr, name, content) {
  if (!content) return;
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let link = document.head.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

// Lightweight per-route SEO: unique <title>, meta description, canonical + OG tags.
// No dependency needed — sets head tags on mount/update.
export function useSeo({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta('meta[name="description"]', "name", "description", description);

    const url = `${SITE_ORIGIN}${path || window.location.pathname}`;
    upsertLink("canonical", url);

    upsertMeta('meta[property="og:title"]', "property", "og:title", title);
    upsertMeta('meta[property="og:description"]', "property", "og:description", description);
    upsertMeta('meta[property="og:url"]', "property", "og:url", url);
    upsertMeta('meta[property="og:type"]', "property", "og:type", "website");
    upsertMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
  }, [title, description, path]);
}
